<div class="no-content-wrapper">
  <div class="no-content-icon" [style]="style"></div>
  <span class="no-content-heading" *ngIf="heading">
    {{heading | translate}}
  </span>
  <span class="no-content-text" *ngIf="text" [class.mt20]="!heading">
    {{text | translate}}
  </span>
</div>

<ng-content></ng-content>